export enum MmSideNavBarButtonsEnum {
  MainGroup = 'Main',
  FilterGroup = 'filter',
  FilterLayout = 'filter-layout',
  FilterStructure = 'filter-str',
  Faults = 'faults',
  UserSettingsBackToProject = 'user-settings-back-to-project',
  UserSettingsGroup = 'user-settings',
  UserSettingsVariables = 'user-settings-variables',

  ProjectSettingsGroup = 'project-settings',
  ProjectSettingsBackToMain = 'project-settings-back-to-main',
  ProjectSettingsCompanies = 'project-settings-companies',
  ProjectSettingsCrafts = 'project-settings-crafts',
  ProjectSettingsUserdefineds1 = 'project-settings-userdefineds1',
  ProjectSettingsUserdefineds2 = 'project-settings-userdefineds2',

  ProjectVariables = 'project-variables',
  Plans = 'plans',
  // Attachments = 'attachments',
  // SettingsGroup = 'settings',
  // SettingsFields = 'settings-fields',
  // SettingsCommon = 'settings-common',

  MessageCenter = 'task-dashboard'
}
